import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from "./auth/login/login.component"
import { AppComponent } from "./app.component";
import { NoAuthGuard } from "./core/services/no-auth-guard.service";
import { AuthGuard } from "./core/services/auth-guard.service";
import { HomeComponent } from "./pages/home/home.component";
import { QrcodeComponent } from "./pages/qrcode/qrcode.component";
import { VerifyComponent } from "./pages/verify/verify.component";
import { OrderComponent } from "./pages/order/order.component";
import { FinanceComponent } from "./pages/finance/finance.component";
import { VerifyfailComponent } from "./pages/verifyfail/verifyfail.component";

const routes: Routes = [
  { path: 'merchant/order', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'merchant/order/qrcode', component: QrcodeComponent, canActivate: [AuthGuard] },
  { path: 'merchant/order/verify', component: VerifyComponent, canActivate: [AuthGuard] },
  { path: 'merchant/order/verifyfail', component: VerifyfailComponent, canActivate: [AuthGuard] },
  { path: 'merchant/order/list', component: OrderComponent, canActivate: [AuthGuard] },
  { path: 'merchant/finance/list', component: FinanceComponent, canActivate: [AuthGuard] },
  { path: '', component: LoginComponent },
  // { path: '', component: MobileInputComponent },  
  // { path: '', component: SuccessComponent, canActivate: [AuthGuard] },

  // otherwise redirect to home 
  /*{ path: '**', redirectTo: '', component: AppComponent, canActivate: [NoAuthGuard] }*/
  { path: '**', redirectTo: '', component: AppComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
